<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex" [class.justify-content-end]="isRTL">
        <button type="button" mat-icon-button aria-label="Toggle sidenav" (click)="closePropertyExplainDialog()"
            class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- --------------- NORMAL property -->
    <div *ngIf="property !== 'paper' && property !== 'pricing' && property !== 'material'"
        class="d-flex flex-grow-1 flex-column align-items-center px-4 py-3 gap-2 w-100">
        <!-- title -->
        <h4 class="text-center fw-bold m-0 pt-3 text-green zx-text-big" [class.zx-ltr]="!isRTL"
            [class.text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
            {{ (!isCollectOptions ? "printing-table.explain-title-" : "collect.") + property +
            (!isCollectOptions ? "" : ".title") | translate }}
        </h4>
        <!-- explain -->
        <div *ngIf="!isCollectOptions" class="d-flex flex-column gap-3 w-100 pt-2 align-items-center">
            <span class="pb-2 text-center" [class.zx-ltr]="!isRTL" [class.text-start]="!isRTL" [class.zx-ltr]="!isRTL"
                [class.zx-text-white]="isDarkMode">
                {{ "printing-table.explain-" + property | translate }}
            </span>
        </div>
        <span *ngIf="!isCollectOptions && !(isPh && (property === 'fill' || property === 'material' || property === 'color' || property === 'estimated-dimensions' || property === 'usage' || property === 'additional-info' || property === 'ph-print-original-size-unavailable'))" class="text-green text-center pt-2 pb-4" [class.zx-text-white]="isDarkMode">
            {{ "printing-table.explain-view-preview" | translate }}
        </span>
        <button *ngIf="isPaperChoosen && !isCollectOptions" type="button" mat-raised-button color="primary"
            class="w-100 rounded-pill zx-small-btn zx-text-white" (click)="openPreviewDialog()">
            <b>
                {{ 'printing-table.preview' | translate }}
            </b>
        </button>
        <!-- Collect explain times -->
        <div *ngIf="isCollectOptions" class="d-flex flex-column gap-2 w-100 px-md-5" [class.text-white]="isDarkMode">
            <!-- adress -->
            <u class="pt-2 pt-md-3">
                <span>
                    {{ "collect.collect-options." + selectedCollectOption | translate }}
                </span>
                <span *ngIf="(selectedCollectOption === 'pickup' || selectedCollectOption === 'appointment') &&
                product.places.length > 1">
                    <span>(</span>
                    <span>
                        {{ "choose-system.step-1" | translate }}
                    </span>
                    <span>)</span>
                </span>
            </u>
            <span class="opacity-75 px-2 px-sm-3">
                <span *ngIf="selectedCollectOption === 'pickup' || selectedCollectOption === 'appointment'">
                    <span class="d-flex flex-column gap-1">
                        <div *ngFor="let place of product.places; let i = index"
                            [class.d-none]="product.places.length > 2">
                            <span *ngIf="i < 3">
                                <span *ngIf="product.places.length > 1">
                                    {{ (i + 1) + ". " }}
                                </span>
                                <span>
                                    {{ "choose-branch.naming." + place.name | translate }}
                                </span>
                            </span>
                            <span *ngIf="i < 2">
                                {{ "collect.in-adress" | translate }}
                            </span>
                            <span *ngIf="i < 2">
                                {{ "choose-branch.short-address." + place.name | translate
                                }}
                            </span>
                            <span *ngIf="i === 2">...</span>
                        </div>
                    </span>
                </span>
                <span *ngIf="selectedCollectOption === 'points' || selectedCollectOption === 'delivery'">
                    {{ "collect." + selectedCollectOption + ".exp" | translate }}
                </span>
            </span>
            <!-- price -->
            <u class="pt-2 pt-md-3">
                {{ "collect.price." +
                ((selectedCollectOption === 'pickup' || selectedCollectOption === 'appointment') ?
                'extra' : (selectedCollectOption === 'delivery' ? 'delivery' : 'distribution'))
                | translate }}
            </u>
            <span class="opacity-75 px-2 px-sm-3">
                <span *ngIf="selectedCollectOption === 'pickup'">
                    {{ "collect.price.none" | translate }}
                </span>
                <span *ngIf="selectedCollectOption !== 'pickup'">
                    <span>
                        {{ getCollectionServicePrice(selectedCollectOption) }}
                    </span>
                    <span class="zx-text-tiny">
                        {{ "printing-table.nis" | translate }}
                    </span>
                    <span *ngIf="selectedCollectOption === 'appointment'">
                        <span>
                            {{ "collect.price.one-hour" | translate }}
                        </span>
                        <span>
                            {{ getCollectionServicePrice(selectedCollectOption) / 2 }}
                        </span>
                        <span class="zx-text-tiny">
                            {{ "printing-table.nis" | translate }}
                        </span>
                        <span>
                            {{ "collect.price.extra-hour" | translate }}
                        </span>
                    </span>
                </span>
            </span>
            <!-- times -->
            <u *ngIf="selectedCollectOption !== 'appointment'" class="pt-2 pt-md-3">
                <span>
                    {{ "collect.times.manufacturing" | translate }}
                </span>
                <span> - </span>
                <span>
                    {{ "choose-product.naming." + productName | translate }}
                </span>
            </u>
            <span class="opacity-75 px-2 px-sm-3"
                *ngIf="selectedCollectOption !== 'appointment' && !isWeekendExplain()">
                <span>
                    {{ 'collect.times.order-sent' | translate }}
                </span>
                <span>
                    {{ 'collect.times.today' | translate }}
                </span>
                <span>
                    (
                </span>
                <span>
                    {{ getDayName(0, false, false, false) }}
                </span>
                <span>
                    )
                </span>
                <span>
                    {{ 'collect.times.until' | translate }}
                </span>
                <span>
                    {{ !isAfterHour() ? getHour() : "00:00" }}
                </span>
                <span>
                    {{ ('collect.' + selectedCollectOption + '.ready') | translate }}
                </span>
                <span *ngIf="extraDaysAndSkipWeekend(0, true) <= 2">
                    {{ 'collect.times.' +
                    (extraDaysAndSkipWeekend(0, true) === 2 ? 'day-after-tomorrow' : 'tomorrow')
                    | translate }}
                </span>
                <span *ngIf="extraDaysAndSkipWeekend(0, true) === 1 || extraDaysAndSkipWeekend(0, true) === 2">
                    (
                </span>
                <span>
                    {{ 'collect.times.at-day' | translate }}
                </span>
                <span>
                    {{
                    isAfterHour() ?
                    (getDayName(1, true, true, true)) :
                    (getDayName(0, false, true, true))
                    }}
                </span>
                <span *ngIf="extraDaysAndSkipWeekend(0, true) === 1 || extraDaysAndSkipWeekend(0, true) === 2">
                    ,
                </span>
                <span>
                    {{
                    isAfterHour() ?
                    (getDateName(1, true, true, true)) :
                    (getDateName(0, false, true, true))
                    }}
                </span>
                <span *ngIf="extraDaysAndSkipWeekend(0, true) === 1 || extraDaysAndSkipWeekend(0, true) === 2">
                    )
                </span>
                <span>
                    .
                </span>
            </span>
            <span class="opacity-75 px-2 px-sm-3" *ngIf="selectedCollectOption !== 'appointment'">
                <span *ngIf="isWeekendExplain()">
                    {{ 'collect.times.weekend-exp' | translate }}
                </span>
                <span *ngIf="!isWeekendExplain()">
                    {{ 'collect.times.order-sent' | translate }}
                </span>
                <span>
                    {{ 'collect.times.' + (isAfterHour() ? 'tomorrow' : 'today') | translate }}
                </span>
                <span>
                    (
                </span>
                <span>
                    {{ isAfterHour() ?
                    (getDayName(1, false, false, false)) :
                    (getDayName(0, false, false, false))
                    }}
                </span>
                <span>
                    )
                </span>
                <span>
                    {{ 'collect.times.' + (!isAfterHour() ? 'after' : 'until') | translate }}
                </span>
                <span>
                    {{ getHour() }}
                </span>
                <span>
                    {{ ('collect.' + selectedCollectOption + '.ready') | translate }}
                </span>
                <span *ngIf="extraDaysAndSkipWeekend(1, true) === 1 || extraDaysAndSkipWeekend(1, true) === 2">
                    {{ 'collect.times.' +
                    (extraDaysAndSkipWeekend(1, true) === 1 ? 'tomorrow' : 'day-after-tomorrow')
                    | translate }}
                </span>
                <span *ngIf="extraDaysAndSkipWeekend(1, true) === 1 || extraDaysAndSkipWeekend(1, true) === 2">
                    (
                </span>
                <span>
                    {{ 'collect.times.at-day' | translate }}
                </span>
                <span>
                    {{
                    isAfterHour() ?
                    (getDayName(2, true, true, true)) :
                    (getDayName(1, false, true, true))
                    }}
                </span>
                <span *ngIf="extraDaysAndSkipWeekend(1, true) === 1 || extraDaysAndSkipWeekend(1, true) === 2">
                    ,
                </span>
                <span>
                    {{
                    isAfterHour() ?
                    (getDateName(2, true, true, true)) :
                    (getDateName(1, false, true, true))
                    }}
                </span>
                <span *ngIf="extraDaysAndSkipWeekend(1, true) === 1 || extraDaysAndSkipWeekend(1, true) === 2">
                    )
                </span>
                <span *ngIf="isWeekendExplain()">
                    {{ 'collect.times.weekend-after' | translate }}
                </span>
                <span>
                    .
                </span>
            </span>
            <!-- // times -->
            <button type="button" mat-raised-button color="primary"
                class="w-100 rounded-pill zx-small-btn zx-text-white mt-4" (click)="updateCollectOptions()">
                <b>
                    {{ 'collect.' + property + '.btn' | translate }}
                </b>
            </button>
        </div>
        <!-- // Collect explain times -->
    </div>
    <!-- // --------------- NORMAL property -->

    <!-- --------------- PAPER property -->
    <div *ngIf="property === 'paper' || property === 'pricing'"
        class="d-flex flex-grow-1 flex-column align-items-center px-4 py-3 gap-2 w-100"
        style="max-height: 100vh !important;">
        <!-- title -->
        <h4 *ngIf="printingService !== 'ph'" class="text-center fw-bold m-0 pt-3 pt-lg-0 text-green zx-text-big"
            [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
            <span *ngIf="property === 'paper'">
                {{ "printing-table.explain-title-paper" | translate }}
            </span>
            <span *ngIf="property === 'pricing'">
                {{ "printing-table.explain-title-pricing" | translate }}
            </span>
            <span *ngIf="realBranch.name">
                <span>
                    {{ ('choose-branch.naming.' + realBranch.name | translate) | slice:0:12 }}
                </span>
                <span *ngIf="('choose-branch.naming.' + realBranch.name | translate).length > 12">
                    ..
                </span>
            </span>
            <span>
                {{ "when-to-print-explanation-now-express-2" | translate }}
            </span>
        </h4>
        <h4 *ngIf="printingService === 'ph'" class="text-center fw-bold m-0 pt-3 pt-lg-0 text-green zx-text-big"
            [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
            <span *ngIf="property === 'paper'">
                {{ "printing-table.explain-title-type" | translate }}
            </span>
            <span *ngIf="property === 'pricing'">
                {{ "printing-table.explain-title-pricing-type" | translate }}
            </span>
            <span> - </span>
            <span *ngIf="realBranch.name">
                {{ 'choose-product.naming.' + realBranch.name | translate }}
            </span>
            <span>
                {{ "when-to-print-explanation-now-express-2" | translate }}
            </span>
        </h4>
        <app-paper-tooltip-content class="pb-2" [property]="property" [printingService]="printingService"
            [isInModal]="true" [inputBins]="inputBins" [printServicePapers]="printServicePapers"
            [realBranch]="realBranch">
        </app-paper-tooltip-content>
    </div>
    <!-- // --------------- PAPER property -->

    <!-- --------------- MATERIAL property -->
    <div *ngIf="property === 'material'"
        class="d-flex flex-grow-1 flex-column align-items-center px-4 py-3 gap-2 w-100"
        style="max-height: 100vh !important;">
        <!-- title -->
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0 text-green zx-text-big"
            [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
            {{ "printing-table.explain-title-material" | translate }}
            <span *ngIf="materialData && materialData.productName">
                <span> - </span>
                <span>
                    {{ 'choose-product.naming.' + materialData.productName | translate }}
                </span>
            </span>
        </h4>
        <div *ngFor="let material of availableMaterials" class="w-100 d-flex flex-column gap-1 p-2"
            [class.zx-border-top-gray-25-pr]="material !== availableMaterials[0]">
            <!-- =========== title (+ optional same-line recommended suffix) =========== -->
            <div class="zx-text-small pb-1 w-100" [class.zx-ltr]="!isRTL" [class.text-end]="isRTL" [class.text-start]="!isRTL">
                <b [class.zx-text-white]="isDarkMode">
                    {{ "product-material.name." + (materialData?.productName || '') + "-" + material.name | translate }}</b><span
                    *ngIf="isFirstRecommendedMaterial(material)"
                    class="fw-normal opacity-90" [class.zx-text-white]="isDarkMode">
                    {{ 'printing-table.3d-material-recommended-suffix' | translate }}
                </span>
            </div>
            <!-- // =========== title =========== -->

            <!-- =========== description =========== -->
            <span class="zx-text-tiny pt-1" [class.zx-ltr]="!isRTL" [class.text-start]="!isRTL" [class.zx-text-white]="isDarkMode">
                {{ "product-material.description." + (materialData?.productName || '') + "-" + material.name | translate }}
            </span>
            <!-- // =========== description =========== -->
        </div>
    </div>
    <!-- // --------------- MATERIAL property -->

</div>